import React, { useState } from "react";

export function ForgotPassword() {
  const [email, setEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();

    await fetch("https://biosurgebackend-1.onrender.com/api/userdata/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

   alert(
  "If your email is registered, you’ll receive password reset instructions shortly."
);

  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={submit}>
        <h2 className="auth-heading">Forgot Password</h2>

        <div className="form-group">
          <label>Registered Email Address</label>
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button className="btn auth-btn" type="submit">
          Send Reset Link
        </button>

        <div className="auth-switch">
          Remembered your password?{" "}
          <span className="auth-link" onClick={() => window.location.href = "/login"}>
            Login
          </span>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
